import React from "react";
// hook
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
// UI
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
// common
import {
  priceInputBySign,
  decimalPointIsLenth,
} from "../../../modules/components/numberFormat/NumberFormat.Currency";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableRow: {
      minHeight: "48px",
      "& td:not(:first-child)": {
        borderLeft: "1px solid rgba(198, 209, 221)",
      },
      "& td": {
        paddingTop: "3.5px",
        paddingBottom: "2px",
        paddingLeft: "10px",
        paddingRight: "10px",
        "&:not(:first-child)": {
          verticalAlign: "top",
          paddingTop: "8px",
          paddingBottom: "5px",
        },
      },
      "&:last-child td": {
        borderBottom: "none",
      },
    },
    checkbox: {
      minHeight: "42px",
    },
    discountRate: {
      display: "flex",
      "& .MuiInputBase-root": {
        marginRight: "5px",
      },
      "& .MuiInputBase-input": {
        textAlign: "right",
        paddingRight: "5px !important",
      },
    },
    packet: {
      "& .MuiInputBase-input": {
        textAlign: "right",
        paddingRight: "5px !important",
      },
      "& .MuiFormControl-root": {
        width: "100%",
      },
    },
    unit: {
      marginTop: "6px",
    },
  })
);

export const PromotionDetailConditionsUnitBaseTableTbody = (props: any) => {
  const { selected } = props;
  const classes = useStyles();
  const isSelected = (name: string) => selected.indexOf(name) > -1;

  return (
    <TableBody data-testid="condition_unit_base_body">
      {props.data.map((row: any, index: number) => {
        const isItemSelected = isSelected(row.index);
        const errorData = props.errorValueList.condition_unit_base;
        const errorFlg1 =
          errorData && errorData[index] && errorData[index].packet_error !== "";
        const errorFlg2 =
          errorData &&
          errorData[index] &&
          errorData[index].discount_rate_error !== "";
        const type = "condition_unit_base";
        return (
          <TableRow
            className={classes.tableRow}
            hover={true}
            tabIndex={-1}
            key={row.index}
            selected={isItemSelected}
          >
            <TableCell padding="checkbox">
              <div
                className={classes.checkbox}
                data-testid={"condition_unit_base_checkbox" + index}
              >
                {
                  <Checkbox
                    checked={isItemSelected}
                    onClick={(event) => props.handleClick(event, row)}
                    disabled={props.reviewFlg}
                  />
                }
              </div>
            </TableCell>
            <TableCell>
              <div
                className={classes.packet}
                data-testid={"unitBase_packet" + index}
              >
                <TextField
                  variant="outlined"
                  value={row.packet}
                  onChange={(e) => {
                    if (props.unitBaseOrAmountBaseValue === "1") {
                      const value = e.target.value
                        .replace(/[^\d]/g, "")
                        .substr(0, 10);
                      props.setCustomFieldValue("packet", value, index, type);
                    }
                  }}
                  onBlur={(e) =>
                    props.changeDataListen(
                      "unitBase_packet",
                      e.target.value,
                      index
                    )
                  }
                  error={errorFlg1}
                  helperText={errorFlg1 ? errorData[index].packet_error : ""}
                  disabled={props.reviewFlg}
                />
              </div>
            </TableCell>
            <TableCell>
              <div
                className={classes.discountRate}
                data-testid={"unitBase_discountRate" + index}
              >
                <TextField
                  variant="outlined"
                  value={row.discount_rate_format}
                  onChange={(e) => {
                    if (props.unitBaseOrAmountBaseValue === "1") {
                      let value = "";
                      let _discount_rate = priceInputBySign(e.target.value);
                      if (
                        !isNaN(_discount_rate) &&
                        _discount_rate >= 0 &&
                        decimalPointIsLenth(e.target.value)
                      ) {
                        value = e.target.value.slice(0, 11);
                      } else {
                        value = row.discount_rate_format
                          ? row.discount_rate_format
                          : "";
                      }
                      props.setCustomFieldValue(
                        "discount_rate",
                        value,
                        index,
                        type
                      );
                    }
                  }}
                  onBlur={(e) =>
                    props.changeDataListen(
                      "unitBase_discount_rate",
                      e.target.value,
                      index
                    )
                  }
                  error={errorFlg2}
                  helperText={
                    errorFlg2 ? errorData[index].discount_rate_error : ""
                  }
                  disabled={props.reviewFlg}
                />
                <div className={classes.unit}>%</div>
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
